{
  "$id": "wealthlane://forms/tax-period",
  "$schema": "wealthlane://schemas/form-model",
  "domain": "../tax-period.domain.json",
  "properties": {
    "name": {
      "$ref": "module://tax-period#properties/name",
      "required": true
    },
    "effectiveFrom": {
      "$ref": "module://tax-period#properties/effectiveFrom",
      "required": true
    },
    "effectiveTill": {
      "$ref": "module://tax-period#properties/effectiveTill",
      "required": true,
      "reactions": [
        {
          "watch": ["effectiveFrom"],
          "set": "minDate",
          "compute": {
            "operator": "field",
            "name": "effectiveFrom"
          }
        }
      ]
    }
  },
  "dataSource": {
    "submit": {
      "actionId": "SAVE_TAX_PERIOD",
      "refreshEntities": ["tax-period"],
      "invalidateQueries": ["getTaxPeriodTableList"]
    }
  },
  "modes": {
    "create": {
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "edit": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_TAX_PERIOD_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        }
      },
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "view": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_TAX_PERIOD_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        }
      },
      "viewPresentation": "disabled-inputs"
    }
  }
}
